<template>
  <div
    class="fixed inset-0 bg-[#F8FAFC] z-10"
    :style="{
      top: '64px',
      left: '256px',
    }"
  >
    <!-- 左侧内容区 -->
    <div
      class="absolute inset-0 overflow-y-auto"
      :style="{
        right: '380px',
        paddingBottom: `${inputHeight + 24}px`,
      }"
    >
      <div class="px-6 py-6">
        <div class="max-w-3xl mx-auto">
          <slot />
        </div>
      </div>
    </div>

    <!-- 底部输入区 -->
    <div
      ref="inputAreaRef"
      class="absolute bottom-0 left-0 bg-white border-t border-slate-200 px-6 py-4 z-20"
      :style="{
        right: '380px',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.05)',
      }"
    >
      <slot name="inputArea" />
    </div>

    <!-- 右侧边栏 -->
    <div
      class="absolute top-0 right-0 bottom-0 w-[380px] bg-white border-l border-slate-200 overflow-y-auto custom-scrollbar"
    >
      <div class="p-6 space-y-6">
        <!-- 专家推荐 -->
        <div>
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center gap-2">
              <IconUsers :size="20" class-name="text-[#F2C94C]" />
              <h3 class="font-bold text-slate-900">为您匹配的专家</h3>
            </div>
            <button class="text-sm text-slate-500 hover:text-[#F2C94C] flex items-center gap-1">
              更多 <IconChevronRight :size="16" />
            </button>
          </div>

          <div class="space-y-3">
            <div
              v-for="expert in matchedExperts"
              :key="expert.id"
              class="flex items-center gap-3 p-3 bg-slate-50 rounded-xl hover:bg-slate-100 cursor-pointer transition-colors group"
              @click="goToExpert(expert.id)"
            >
              <img
                :src="expert.avatar"
                :alt="expert.name"
                class="w-12 h-12 rounded-full object-cover border-2 border-transparent group-hover:border-[#F2C94C] transition-colors"
                referrerpolicy="no-referrer"
              />
              <div class="flex-1 min-w-0">
                <p class="font-bold text-slate-900 truncate">{{ expert.name }}</p>
                <p class="text-xs text-slate-500 truncate">
                  {{ expert.department ? `${expert.department} · ${expert.position || expert.title}` : expert.title }}
                </p>
                <div class="flex gap-1 mt-1 flex-wrap">
                  <span
                    v-for="(t, i) in expert.topics.slice(0, 2)"
                    :key="i"
                    class="px-2 py-0.5 bg-[#F2C94C]/10 text-[#F2C94C] text-xs rounded"
                  >
                    {{ t }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 针对性训练 -->
        <div>
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center gap-2">
              <IconGamepad2 :size="20" class-name="text-[#F2C94C]" />
              <h3 class="font-bold text-slate-900">针对性训练</h3>
            </div>
          </div>

          <div class="space-y-3">
            <div
              v-for="(scenario, i) in recommendedScenarios"
              :key="scenario.id"
              class="p-4 bg-slate-50 rounded-xl hover:bg-slate-100 cursor-pointer transition-colors group"
              @click="goToPractice"
            >
              <div class="flex items-start justify-between mb-2">
                <span class="px-2 py-1 bg-[#F2C94C]/10 text-[#F2C94C] text-xs font-bold rounded">
                  情景演练
                </span>
                <span class="text-xs text-slate-400">匹配度 {{ 95 - i * 3 }}%</span>
              </div>
              <h4 class="font-bold text-slate-900 mb-1 group-hover:text-[#F2C94C] transition-colors line-clamp-1">
                情景演练 {{ i + 1 }}
              </h4>
              <p class="text-sm text-slate-500 line-clamp-2 mb-3">
                {{ scenario.description }}
              </p>
              <button class="w-full py-2 bg-white border border-slate-200 rounded-lg text-sm font-bold text-slate-700 hover:bg-[#F2C94C] hover:text-[#1B3C59] hover:border-[#F2C94C] transition-colors">
                开始演练
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EXPERTS, SCENARIO_DATA } from '../../data'
import IconUsers from '../icons/IconUsers.vue'
import IconGamepad2 from '../icons/IconGamepad2.vue'
import IconChevronRight from '../icons/IconChevronRight.vue'

export default {
  name: 'DiagnoseResultLayout',
  components: {
    IconUsers,
    IconGamepad2,
    IconChevronRight,
  },
  data() {
    return {
      inputHeight: 80,
      matchedExperts: EXPERTS.slice(0, 2),
      recommendedScenarios: Object.values(SCENARIO_DATA).slice(0, 2),
    }
  },
  mounted() {
    this.setupResizeObserver()
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  },
  methods: {
    setupResizeObserver() {
      const el = this.$refs.inputAreaRef
      if (el) {
        this.resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            this.inputHeight = entry.contentRect.height
          }
        })
        this.resizeObserver.observe(el)
      }
    },
    goToExpert(expertId) {
      this.$router.push(`/expert/${expertId}`)
    },
    goToPractice() {
      this.$router.push('/practice')
    },
  },
}
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #F2C94C;
  border-radius: 3px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #E5B73B;
}
</style>
